import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function FranchiseActivityPage() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.franchiseActivity(500).then((r) => setRows(r.data || [])).catch(() => setRows([])); }, []);
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold font-heading">Activity log</h1>
      <Card className="p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/40 text-xs uppercase tracking-wider text-muted-foreground">
            <tr><th className="py-3 px-4 text-left">When</th><th className="py-3 px-4 text-left">Who</th><th className="py-3 px-4">Role</th><th className="py-3 px-4 text-left">Action</th><th className="py-3 px-4 text-left">Details</th></tr>
          </thead>
          <tbody>
            {rows === null ? <tr><td colSpan={5} className="py-10 text-center">Loading…</td></tr>
              : rows.length === 0 ? <tr><td colSpan={5} className="py-10 text-center text-muted-foreground">No activity yet.</td></tr>
              : rows.map((r) => (
                <tr key={r.id} className="border-t border-border">
                  <td className="py-2 px-4 whitespace-nowrap text-muted-foreground">{new Date(r.at).toLocaleString()}</td>
                  <td className="py-2 px-4">{r.actor_email}</td>
                  <td className="py-2 px-4 text-center"><Badge variant="secondary" className="text-[10px]">{r.actor_role}</Badge></td>
                  <td className="py-2 px-4 font-mono text-[11px]">{r.action}</td>
                  <td className="py-2 px-4 font-mono text-[10px] text-muted-foreground truncate max-w-md">{r.meta ? JSON.stringify(r.meta) : ""}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
